import { Box, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import { FC } from 'react';
const INTEGRATION_LOGOS = ['Dealer inspire.png', 'VinSolutions.png', 'DealerCOM.png', 'CDK elead.png', 'DealerCenter.png', 'DriveCentric.png', 'vAuto.png', 'DEP.png', 'Motive.png', 'Homenet.png', 'Apollo.png', 'dealeron.png'];
export const Integrations: FC = () => {
  return <Box>
      <Typography sx={{
      fontSize: '38px',
      textAlign: 'center',
      fontWeight: 700
    }}>
        We integrate and partner with top automotive players
      </Typography>
      <Grid container>
        {INTEGRATION_LOGOS.map((item, i) => <Grid item xs={6} md={3} key={i} spacing={4} sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}>
            <Image src={`/assets/images/new-partners/${item}`} alt={item} width={140} height={140} style={{
          opacity: '80%'
        }} />
          </Grid>)}
      </Grid>
    </Box>;
};